const { SET_SEARCH_RESULT, CLOSE_SEARCH_RESULT } = require("../types");

const INITIAL_STATE = {
  searchResult: [],
  openSearchResult: false,
};


const searchReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch(type) {
    case SET_SEARCH_RESULT:
      return {
        ...state,
        searchResult: payload,  
        openSearchResult: true,
      }
    case CLOSE_SEARCH_RESULT:
      return {
        ...state,
        searchResult: [],
        openSearchResult: false,
      }
    default:
      return state; 
  }
}


export default searchReducer;